import { create } from "zustand";
import type { OrganizationType } from "../types";

interface OrgTypesState {
	modalOpen: boolean;
	editingItem: OrganizationType | null;
}

interface OrgTypesActions {
	openCreateModal: () => void;
	openEditModal: (item: OrganizationType) => void;
	onOpen: (item?: OrganizationType) => void;
	closeModal: () => void;
}

type OrgTypesStore = OrgTypesState & OrgTypesActions;

export const useOrgTypesStore = create<OrgTypesStore>((set) => ({
	modalOpen: false,
	editingItem: null,

	openCreateModal: () => {
		set({ modalOpen: true, editingItem: null });
	},

	openEditModal: (item) => {
		set({ modalOpen: true, editingItem: item });
	},

	onOpen: (item) => {
		set({ modalOpen: true, editingItem: item ?? null });
	},

	closeModal: () => {
		set({ modalOpen: false, editingItem: null });
	},
}));
